import { render, staticRenderFns } from "./EmployeeLocations.vue?vue&type=template&id=22865f48"
import script from "./EmployeeLocations.vue?vue&type=script&lang=js"
export * from "./EmployeeLocations.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLocations.vue?vue&type=style&index=0&id=22865f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QSelect,QIcon,QBtn,QPopupProxy,QCardSection,QInput,QDate,QToggle,QItem,QItemSection,QItemLabel,QChip,QDialog});qInstall(component, 'directives', {ClosePopup});
